import { sellerTableHeader, sellerTableRow } from "../../../Component/style/sellerTable";
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import api from "../../../Component/axios_Interceptor/api";
import url from "../../../Component/server";

import Layout_Admin from "../../../Component/UI/Layout_Admin";
import AdminPageHeader, { AdminActionButton } from "../../../Component/UI/AdminPageHeader";
import { amountFormat } from "../../../Component/tool/Tools";
import { CenterView, RowView } from "../../../Component/style/common_style";
import PagingControl from "../../../Component/UI/PagingControl";
import CoinChargeModal from "./Modal/CoinChargeModal";
import CompleteModal from "./Modal/CompleteModal";

interface listData {
  log_type: string;
  log_dt: string;
  log_con: string;
  coin: number;
  r_coin: number;
  coin_check: string;
  seq: number;
  requested_depositor?: string | null;
}

type CoinHistoryFilters = { search_value: string; start_date: string; end_date: string };
const emptyHistoryFilters: CoinHistoryFilters = { search_value: '', start_date: '', end_date: '' };
const historyDate = (daysAgo = 0) => new Date(Date.now() + 9 * 60 * 60 * 1000 - daysAgo * 86400000).toISOString().slice(0, 10);

const CoinManage = () => {
  const [draftFilters, setDraftFilters] = useState<CoinHistoryFilters>({ ...emptyHistoryFilters });
  const [historyFilters, setHistoryFilters] = useState<CoinHistoryFilters>({ ...emptyHistoryFilters });
  const [filterError, setFilterError] = useState('');
  const updateFilter = (key: keyof CoinHistoryFilters, value: string) => {
    setDraftFilters(previous => ({ ...previous, [key]: value }));
    setFilterError('');
  };
  const searchHistory = (event: React.FormEvent) => {
    event.preventDefault();
    if (draftFilters.start_date && draftFilters.end_date && draftFilters.start_date > draftFilters.end_date) {
      setFilterError('시작일은 종료일보다 늦을 수 없습니다.');
      return;
    }
    setFilterError('');
    setCurrentPage(1);
    setHistoryFilters({ ...draftFilters, search_value: draftFilters.search_value.trim() });
  };
  const resetHistory = () => {
    setDraftFilters({ ...emptyHistoryFilters });
    setHistoryFilters({ ...emptyHistoryFilters });
    setFilterError('');
    setSelect('전체');
    setCurrentPage(1);
  };
  const setPeriod = (days: number | null) => {
    setDraftFilters(previous => ({ ...previous, start_date: days ? historyDate(days - 1) : '', end_date: days ? historyDate() : '' }));
    setFilterError('');
  };

  const [reload, setReload] = useState(0);
  const [myCoin, setMyCoin] = useState<number | null>(null);
  const [balanceState, setBalanceState] = useState<'loading' | 'ready' | 'error'>('loading');
  const [listState, setListState] = useState<'loading' | 'ready' | 'error'>('loading');
  const [mutationError, setMutationError] = useState('');
  const [cancelling, setCancelling] = useState<number | null>(null);
  const cancelInFlight = useRef(false);
  const mounted = useRef(true);
  const [select, setSelect] = useState("전체");
  const handleSelect = (data: string) => {
    setSelect(data);
    setCurrentPage(1);
  };
  const [cnt, setCnt] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [list, setList] = useState<listData[]>([]);

  // 충전 모달
  const [visible, setVisible] = useState(false);
  const handleModal = () => {
    setVisible(value => !value);
  };

  // 입금정보 모달
  const [completeVisible, setCompleteVisible] = useState(false);
  const handleCompleteModal = () => {
    setCompleteVisible(value => !value);
  };
  const [selectedDeposit, setSelectedDeposit] = useState<listData | null>(null);

  // 보유 코인 조회
  useEffect(() => {
    mounted.current = true;
    return () => { mounted.current = false; };
  }, []);

  // 코인 내역 조회
  useEffect(() => {
    let active = true;
    const controller = new AbortController();
    setBalanceState('loading');
    api.get(url.Communication_url.stock_coin, { signal: controller.signal }).then(res => {
      const coin = res.data?.coin;
      if (coin == null || coin === '' || !Number.isSafeInteger(Number(coin)) || Number(coin) < 0) throw new Error('Invalid balance');
      if (active) { setMyCoin(Number(coin)); setBalanceState('ready'); }
    }).catch(() => { if (active) { setMyCoin(null); setBalanceState('error'); } });
    return () => { active = false; controller.abort(); };
  }, [reload]);

  useEffect(() => {
    let active = true;
    const controller = new AbortController();
    setListState('loading');
    api.get(url.Communication_url.coin_log_list, {
      signal: controller.signal,
      params: { current_page: currentPage, per_page: 20, log_type: select === '전체' ? '' : select,
        search_value: historyFilters.search_value || undefined, start_date: historyFilters.start_date || undefined, end_date: historyFilters.end_date || undefined },
    }).then(res => {
      if (!Array.isArray(res.data?.coinLogList) || res.data.total == null || !Number.isSafeInteger(Number(res.data.total)) || Number(res.data.total) < 0) throw new Error('Invalid history');
      if (!active) return;
      const total = Number(res.data.total);
      const finalPage = Math.max(1, Math.ceil(total / 20));
      if (currentPage > finalPage) { setCurrentPage(finalPage); return; }
      setList(res.data.coinLogList);
      setCnt(total);
      setListState('ready');
    }).catch(() => { if (active) setListState('error'); });
    return () => { active = false; controller.abort(); };
  }, [reload, currentPage, select, historyFilters]);

  const coin_charging_cancel = async (seq: number) => {
    if (cancelInFlight.current) return;
    cancelInFlight.current = true;
    setCancelling(seq);
    setMutationError('');
    try {
      const res = await api.post(url.Communication_url.coin_charging_cancel, {
        seq: seq,
      });
      if (res.data !== '성공') throw new Error('충전 신청 취소 결과를 확인하지 못했습니다.');
      if (mounted.current) handleReload();
    } catch (error) {
      if (mounted.current) { setMutationError('취소 결과를 확인하지 못했습니다. 새로고침한 내역에서 신청 상태를 확인해주세요.'); handleReload(); }
    } finally {
      cancelInFlight.current = false;
      if (mounted.current) setCancelling(null);
    }
  };

  const handleReload = () => {
    setReload(value => value + 1);
  };
  const hasActions = list.some(data => data.log_type === '충전'
    && data.log_con === '코인 충전 입금 대기' && data.coin_check !== 'c');

  return (
    <Layout_Admin menuname={"코인 관리"}>
      <PageContent>
      <CoinOverview>
      <AdminPageHeader className="coin-page-header" title="코인 관리" description="코인 잔액과 충전 내역을 확인합니다." actions={<AdminActionButton type="button" onClick={handleReload} disabled={balanceState === 'loading' || listState === 'loading'}>새로고침</AdminActionButton>} />
      </CoinOverview>
      {balanceState === 'error' && <p role="alert">보유 코인을 불러오지 못했습니다. <button type="button" onClick={handleReload}>다시 조회</button></p>}
      {mutationError && <p role="alert">{mutationError}</p>}
      <ControlRow>
        <CateDiv>
          <Cate type="button" aria-pressed={select === "전체"}
            $select={select === "전체"}
            onClick={() => handleSelect("전체")}
          >
            전체
          </Cate>
          <Cate type="button" aria-pressed={select === "충전"}
            $select={select === "충전"}
            onClick={() => handleSelect("충전")}
          >
            충전
          </Cate>
          <Cate type="button" aria-pressed={select === "사용"}
            $select={select === "사용"}
            onClick={() => handleSelect("사용")}
          >
            사용
          </Cate>
          <Cate type="button" aria-pressed={select === "환불"}
            $select={select === "환불"}
            onClick={() => handleSelect("환불")}
          >
            환불
          </Cate>
        </CateDiv>
      </ControlRow>
      <SearchBalanceRow>
      <HistorySearchForm data-admin-search="" aria-label="코인 내역 검색" onSubmit={searchHistory}>
        <FilterFields>
          <label>검색어<input type="search" maxLength={100} placeholder="내역 또는 입금자명 검색" value={draftFilters.search_value} onChange={event => updateFilter('search_value', event.target.value)} /></label>
          <label>시작일<input type="date" value={draftFilters.start_date} onChange={event => updateFilter('start_date', event.target.value)} /></label>
          <label>종료일<input type="date" value={draftFilters.end_date} onChange={event => updateFilter('end_date', event.target.value)} /></label>
        </FilterFields>
        <FilterActions>
          <PeriodPresets role="group" aria-label="조회 기간 빠른 선택">
            <button type="button" aria-pressed={!draftFilters.start_date && !draftFilters.end_date} onClick={() => setPeriod(null)}>전체 기간</button>
            <button type="button" aria-pressed={draftFilters.start_date === historyDate(6) && draftFilters.end_date === historyDate()} onClick={() => setPeriod(7)}>최근 7일</button>
            <button type="button" aria-pressed={draftFilters.start_date === historyDate(29) && draftFilters.end_date === historyDate()} onClick={() => setPeriod(30)}>최근 30일</button>
          </PeriodPresets>
          <div><AdminActionButton data-admin-search-reset="" type="button" onClick={resetHistory}>초기화</AdminActionButton><AdminActionButton $primary type="submit" disabled={listState === 'loading'}>조회</AdminActionButton></div>
        </FilterActions>
        {filterError && <p role="alert">{filterError}</p>}
      </HistorySearchForm>
      <MyCoinDiv>
        <div>
          <span className="label">보유 코인</span>
          <strong>{balanceState === 'loading' ? '조회 중…' : balanceState === 'error' ? '조회 실패' : `${amountFormat(myCoin as number)} C`}</strong>
          <p>무통장 입금 확인 후 코인이 지급됩니다.</p>
        </div>
        <CoinChargeBtn type="button" onClick={handleModal}>코인 충전하기</CoinChargeBtn>
      </MyCoinDiv>
      </SearchBalanceRow>
      {listState === 'ready' && <ResultCount role="status">총 {amountFormat(cnt)}건</ResultCount>}
      <HistorySurface>
      <Table className="header" $withActions={hasActions}>
        <Row>구분</Row>
        <Row className="flex2">일시</Row>
        <Row className="flex4">내역</Row>
        <Row className="flex2">변동 코인</Row>
        <Row className="flex2">잔여 코인</Row>
        {hasActions && <Row className="flex4">관리</Row>}
      </Table>
      {listState === 'loading' && <p role="status">코인 내역을 불러오는 중입니다.</p>}
      {listState === 'error' && <p role="alert">코인 내역을 불러오지 못했습니다. <button type="button" onClick={handleReload}>다시 조회</button></p>}
      {listState === 'ready' && list.length === 0 && <p>조회된 코인 내역이 없습니다.</p>}
      {listState === 'ready' && list.map((data) => {
        return (
          <Table key={data.seq} $withActions={hasActions}>
            <Row>{data.log_type}</Row>
            <Row className="flex2">{data.log_dt}</Row>
            <Row
              className="flex4"
              $gray={
                data.log_con === "코인 충전 입금 대기" ||
                data.log_con === "코인 충전 취소"
              }
            >
              {data.log_con}
            </Row>
            <Row className="flex2" $log_type={data.log_type}>
              {data.log_con !== "코인 충전 입금 대기" &&
                data.log_con !== "코인 충전 취소" && (
                  <>
                    {data.log_type === "사용" ? "-" : "+"}
                    {/* 부호는 log_type으로 직접 정한다 — data.coin 자체가 이미
                        마이너스로 내려오는 케이스가 섞여 있어(백엔드 데이터 비일관),
                        그대로 이어붙이면 "--500"처럼 부호가 중복될 수 있다. 항상
                        절댓값만 표시해 백엔드가 어느 부호로 주든 한 번만 붙게 한다. */}
                    {amountFormat(Math.abs(Number(data.coin)))}
                  </>
                )}
            </Row>
            <Row className="flex2">
              {data.log_con !== "코인 충전 입금 대기" &&
                data.log_con !== "코인 충전 취소" &&
                amountFormat(data.r_coin)}
            </Row>
            {hasActions && <Row className="btn">
              {data.log_type === "충전" &&
                data.log_con === "코인 충전 입금 대기" &&
                data.coin_check !== "c" && (
                  <InfoBtn
                    type="button" onClick={() => {
                      handleCompleteModal();
                      setSelectedDeposit(data);
                    }}
                  >
                    입금정보
                  </InfoBtn>
                )}
              {data.log_type === "충전" &&
                data.log_con === "코인 충전 입금 대기" &&
                data.coin_check === "n" && (
                  <CancelBtn type="button" disabled={cancelling !== null} onClick={() => coin_charging_cancel(data.seq)}>
                    {cancelling === data.seq ? '취소 중' : '취소'}
                  </CancelBtn>
                )}
            </Row>}
          </Table>
        );
      })}

      {listState === 'ready' && <PagingControl
        cnt={cnt}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />}
      </HistorySurface>
      {visible && <CoinChargeModal
        visible={visible}
        handleModal={handleModal}
        myCoin={balanceState === 'ready' ? myCoin : null}
        handleReload={handleReload}
      />}
      {completeVisible && selectedDeposit && <CompleteModal
        visible={completeVisible}
        handleModal={handleCompleteModal}
        chargeCoin={selectedDeposit.coin}
        depositorName={selectedDeposit.requested_depositor || '미등록'}
        myCoin={myCoin}
      />}
      </PageContent>
    </Layout_Admin>
  );
};

export default CoinManage;

const PageContent = styled.div`
  max-width: 1600px;
  margin: 0 auto;
  color: var(--admin-theme-text, #292633);
`;


const CoinOverview = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-5);
  margin-bottom: var(--space-6);
  .coin-page-header { position: static; width: 100%; margin: 0; padding: 0; border: 0; }
  .coin-page-header::before { display: none; }
`;

const MyCoinDiv = styled.div`
  box-sizing: border-box;
  display: grid;
  grid-template-columns: minmax(0, 1fr) max-content;
  align-items: center;
  gap: var(--space-1) var(--space-4);
  align-content: center;
  width: 100%;
  max-width: 100%;
  padding: var(--space-5);
  border: 1px solid var(--color-border-default);
  border-radius: var(--radius-lg);
  background: var(--color-bg-surface);
  > div { display: contents; }
  .label { grid-column: 1; color: var(--color-text-secondary); font-size: var(--text-caption); }
  strong { grid-column: 1; color: var(--color-text-primary); font-size: var(--text-h1);
    font-weight: var(--font-weight-semibold); line-height: var(--leading-display);
    letter-spacing: var(--tracking-heading); font-variant-numeric: tabular-nums; }
  p { grid-column: 1 / -1; grid-row: 3; margin: var(--space-2) 0 0;
    color: var(--color-text-secondary); font-size: var(--text-caption); }
  > button { grid-column: 2; grid-row: 1 / 3; }
  @media (max-width: 540px) {
    padding: var(--space-4);
    gap: var(--space-2) var(--space-4);
    > button { grid-column: 1 / -1; grid-row: 3; justify-self: start; margin-top: var(--space-2); }
    p { grid-row: 4; }
  }
`;

const CateDiv = styled.div.attrs<{ 'data-admin-tabs'?: string }>({ 'data-admin-tabs': '' })`
  gap: 6px;
  flex-direction: row;
  display: flex;
  flex-wrap: wrap;
`;

const ControlRow = styled(RowView)`
  margin: 0 0 var(--space-4);
  flex-direction: column;
  align-items: stretch;
  gap: var(--space-3);
`;

const Cate = styled.button<{ $select: boolean }>`
  border-radius: 7px;
  border: 1px solid ${(props) => props.$select ? '#51456e' : 'var(--admin-theme-border, #dfdce5)'};
  background: ${(props) => props.$select ? '#51456e' : 'var(--admin-theme-surface, #fff)'};
  color: ${(props) => props.$select ? '#fff' : 'var(--admin-theme-muted, #625d6b)'};
  min-width: 58px;
  min-height: 36px;
  padding: 7px 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font: inherit;
  &:hover { border-color: var(--admin-theme-border, #a994e8); }
  &:focus-visible { outline: 3px solid var(--admin-theme-focus, #a994e8); outline-offset: 2px; }
`;

const CoinChargeBtn = styled(AdminActionButton).attrs({ $primary: true })``;

const SearchBalanceRow = styled.div`
  display: grid; grid-template-columns: minmax(0, 1fr) 360px; gap: var(--space-4); margin-bottom: var(--space-4);
  @media (max-width: 1200px) { grid-template-columns: minmax(0, 1fr); }
`;
const HistorySearchForm = styled.form`
  display: flex; flex-direction: column; gap: var(--space-4);
  container: coin-search / inline-size; min-width: 0; padding: var(--space-5);
  border: 1px solid var(--color-border-default); border-radius: var(--radius-md); background: var(--color-bg-surface);
  p[role="alert"] { margin: 0; color: var(--color-text-danger); font-size: var(--text-caption); }
  @media (max-width: 540px) { padding: var(--space-4); }
`;
const FilterFields = styled.div`
  display: grid; grid-template-columns: minmax(220px, 1fr) repeat(2, minmax(160px, 200px)); gap: var(--space-4);
  label { display: flex; flex-direction: column; gap: var(--space-2); min-width: 0; font-size: var(--text-caption); color: var(--color-text-secondary); }
  input { box-sizing: border-box; width: 100%; min-width: 0; height: var(--control-lg); padding: 0 var(--space-4);
    border: 1px solid var(--color-border-default); border-radius: var(--radius-md); background: var(--color-bg-page); color: var(--color-text-primary); font: inherit; font-size: var(--text-body); }
  input:focus-visible { outline: 2px solid var(--color-focus-ring); outline-offset: 2px; }
  @container coin-search (max-width: 650px) { grid-template-columns: repeat(2, minmax(0, 1fr)); label:first-child { grid-column: 1 / -1; } }
  @media (max-width: 900px) { grid-template-columns: repeat(2, minmax(0, 1fr)); label:first-child { grid-column: 1 / -1; } }
  @media (max-width: 540px) { grid-template-columns: minmax(0, 1fr); }
`;
const FilterActions = styled.div`
  display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: var(--space-4);
  > div:last-child { display: flex; gap: var(--space-2); }
`;
const PeriodPresets = styled.div`
  display: flex; flex-wrap: wrap; gap: var(--space-2);
  button { min-height: var(--touch-target); padding: 0 var(--space-3); border: 1px solid var(--color-border-default); border-radius: var(--radius-md);
    background: var(--color-bg-surface); color: var(--color-text-secondary); font: inherit; font-size: var(--text-caption); cursor: pointer; }
  button[aria-pressed="true"] { border-color: var(--color-brand); background: var(--color-brand-subtle); color: var(--color-text-link); }
  button:hover { border-color: var(--color-brand); }
`;
const ResultCount = styled.p`margin: 0 0 var(--space-3); color: var(--color-text-secondary); font-size: var(--text-caption);`;

const HistorySurface = styled.div`
  border: 1px solid var(--admin-theme-border, #e6e3eb);
  border-radius: 11px;
  background: var(--admin-theme-surface, #fff);
  overflow-x: auto;
`;

const Table = styled(RowView)<{ $withActions: boolean }>`
  ${sellerTableRow}
  display: grid;
  grid-template-columns: ${props => props.$withActions
    ? '90px 190px minmax(220px, 1fr) 150px 160px 160px'
    : '90px 190px minmax(220px, 1fr) 150px 160px'};
  min-width: ${props => props.$withActions ? '970px' : '810px'};
  padding: 0 12px;
  &:not(.header):hover { background: var(--admin-theme-raised, #faf9fc); }
  & > :nth-child(3) { justify-content: flex-start; text-align: left; }
  & > :nth-child(4), & > :nth-child(5), & > :nth-child(6) { justify-content: flex-end; text-align: right; }
  &.header {
    ${sellerTableHeader}
    white-space: nowrap;
    border-radius: 10px 10px 0 0;
  }
`;

const Row = styled(CenterView)<{ $log_type?: string; $gray?: boolean }>`
  min-width: 0;
  padding: 8px 12px;
  line-height: 1.5;
  font-family: var(--font-family-base); font-weight: var(--font-weight-medium);
  div {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  &.flex4 {
    flex: 4;
    color: ${(props) => (props.$gray ? "var(--admin-muted)" : "var(--admin-theme-text, #010101)")};
  }
  &.flex2 {
    color: ${(props) =>
      props.$log_type === "사용"
        ? "var(--admin-theme-danger, #b23b52)"
        : props.$log_type === "충전" || props.$log_type === "환불"
        ? "var(--admin-theme-text, #2d6b5c)"
        : "var(--admin-theme-text, #010101)"};
  }
  &.btn {
    gap: 8px;
  }
`;

const InfoBtn = styled.button`
  background: var(--admin-theme-surface, white);
  width: 74px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--admin-theme-border, #f0f0f0);
  line-height: 32px;
  cursor: pointer;
`;

const CancelBtn = styled.button`
  background: var(--admin-theme-surface, white);
  &:disabled { cursor: wait; opacity: 0.6; }
  width: 50px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--admin-theme-border, #f0f0f0);
  color: var(--admin-muted);
  line-height: 32px;
  cursor: pointer;
`;
